(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDialogController', FunzioneDialogController);

    FunzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Funzione', 'RuoloFunzione'];

    function FunzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Funzione, RuoloFunzione) {
        var vm = this;

        vm.funzione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.ruolofunziones = RuoloFunzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.funzione.id !== null) {
                Funzione.update(vm.funzione, onSaveSuccess, onSaveError);
            } else {
                Funzione.save(vm.funzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:funzioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
